import { KeyboardArrowDown } from '@mui/icons-material'

const { createTheme, responsiveFontSizes } = require('@mui/material/styles')
const colors = require('./theme/colors')

/**
 * @typedef {import('@mui/material/styles').ThemeOptions}
 */

export { colors }

let theme = createTheme({
  transitions: {
    duration: {
      standard: 350,
    },
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#001425',
          fontSize: '0.875rem',
          lineHeight: '18px',
        },
        outlined: {
          transform: 'translate(16px, 75%) scale(1)',
          '&.MuiInputLabel-shrink': {
            transform: 'translate(16px, -8px) scale(0.75)',

          },
        },
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
        notchedOutline: {
          borderColor: '#ccc',
          borderRadius: 0,
        }
      },
    },
    MuiInput: {
      styleOverrides: {
        input: {
          paddingBottom: '16px'
        },
        underline: {
          '&:after': {
            bottom: 0,
            borderBottom: '2px solid #001425'
          },
        },
      }
    },
    MuiSelect: {
      defaultProps: {
        // eslint-disable-next-line react/react-in-jsx-scope
        IconComponent: (props) => <KeyboardArrowDown {...props} />,
      },
      styleOverrides: {
        outlined: {
          borderRadius: '0',
          fontSize: '0.875rem',
          lineHeight: '21px',
          padding: '0.75rem 2.5rem 0.75rem 1rem',
          paddingRight: '3rem!important'
        },
        icon: {
          right: '16px',
          fill: '#002145'
        }
      },
    },
  },
  palette: {
    primary: {
      main: '#002145',
      light: '#2F5D7C',
      contrastText: '#fff',
    },
  },
  typography: {
    fontFamily: [
      '"Whitney SSm A"',
      '"Whitney SSm B"',
      'Arial',
      'Helvetica',
      '"Helvetica Neue"',
      '"Segoe UI"',
      '-apple-system',
      'BlinkMacSystemFont',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(','),
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 980,
      lg: 1200,
      xl: 1600,
    }
  }
})

theme = responsiveFontSizes(theme)

export default theme
